import React from "react";
import { NavLink } from "react-router-dom";

function Transactions(props) {
  const myLists = props.transactionJson;
  const listItems = myLists.map((myList) => (
    <li key={myList.id} className="Array-item">
      <div className="title">{myList.product_object.title}</div>
      <div className="date">{myList.approved_at_fa}</div>
      <div className="describe">
        <b>سریال:</b> {myList.serial_number}
      </div>
      <div className="describe">
        <b>هدیه شما:</b>{" "}
        {myList.user_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
        ریال
      </div>
    </li>
  ));
  return (
    <div className="w-100 body-padding px-2">
      <p className="wp-header">بارکدهای ثبت شده</p>
      <ul className="Array">
        {listItems.length === 0 ? (
          <li className="Array-item">
            <div className="title">هنوز محصولی توسط شما ثبت نشده است.</div>
          </li>
        ) : (
          listItems
        )}
      </ul>
      <button className="btn dina-btn-orange wp-button-complaint">
        <NavLink to="/complaints" className="text-nodecoration">
          شکایات
        </NavLink>
      </button>
    </div>
  );
}

export default Transactions;
